import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';
import { apiUc } from '../../../http';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/centrosdecusto');
  }

  getAllSeachSector(page, size, query, showDisable, login, sortBy, order) {
    return apiUc.get(`${this.path}?q=${query}&showDisable=${showDisable}`, {
      headers: {
        limit: size,
        offset: size * (page - 1),
        login
      },
      params: {
        order: order?.toUpperCase(),
        sortBy: sortBy
      }
    });
  }
}

export default new SectorService();
